<template>
  <div class="nav-bar">
    <!-- 桌面版 -->
    <nav class="el-menu desktop-nav">
      <div class="logo">Hewvo</div>
      <el-menu
        mode="horizontal"
        :default-active="$route.path"
        router
        text-color="#000"
        class="nav-container"
        active-text-color="#FF6B35"
      >
        <el-menu-item index="/home">{{$t('menu.home')}}</el-menu-item>
        <el-menu-item index="/about">{{$t('menu.about')}}</el-menu-item>
        <el-menu-item index="/products">{{$t('menu.products')}}</el-menu-item>
        <el-menu-item index="/solutions">
          {{$t('menu.solutions')}}
<!--          <template slot="title">{{$t('menu.solutions')}}</template>-->
<!--          <el-menu-item index="/solutions">{{$t('menu.solution1')}}</el-menu-item>-->
<!--          <el-menu-item index="/solutions2">{{$t('menu.solution2')}}</el-menu-item>-->
        </el-menu-item >
        <el-menu-item index="/contact">{{$t('menu.contact')}}</el-menu-item>
      </el-menu>
    </nav>

    <!-- 移动版 -->
    <nav class="mobile-nav">
      <div class="brand">Hewvo</div>
      <div class="hamburger" @click="toggleMenu()" :style="{transform: menuOpen ? 'rotate(90deg)' : 'none'}">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="mobile-menu" id="mobileMenu" v-show="menuOpen">
        <div class="mobile-menu-item" @click="goTo('/home')">{{$t('menu.home')}}</div>
        <div class="mobile-menu-item" @click="goTo('/about')">{{$t('menu.about')}}</div>
        <div class="mobile-menu-item" @click="goTo('/products')">{{$t('menu.products')}}</div>
        <div class="mobile-menu-item" @click="goTo('/solutions')">{{$t('menu.solutions')}}</div>
        <div class="mobile-menu-item" @click="goTo('/contact')">{{$t('menu.contact')}}</div>
      </div>
    </nav>
  </div>
</template>
<script>

import {changeLanguage} from "@/utils/language";

export default {
  name: "navbar",
  data() {
    return {
      currentLanguage: this.$i18n.locale,
      languageOptions: [
        { value: 'zh', label: '中文' },
        { value: 'en', label: 'English' }
      ],
      showCommon:"base",
      menuOpen: false
    }
  },

  methods: {
    handleLanguageChange(lang) {
      changeLanguage(lang,this)
      // 这里可以添加其他语言切换逻辑
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    goTo(path) {
      this.menuOpen = false
      this.$router.push({path: path})
    },
// 子菜单切换
    toggleSubmenu() {
      const submenu = document.getElementById('submenu');
      submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
    }
  },
  mounted() {
    // 桌面版悬停交互
    const navItems = document.querySelectorAll('.nav-item');
    navItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        const submenu = item.querySelector('.submenu');
        if (submenu) submenu.style.display = 'block';
      });
      item.addEventListener('mouseleave', () => {
        const submenu = item.querySelector('.submenu');
        if (submenu) submenu.style.display = 'none';
      });
    });
  }
}
</script>
<style lang="scss">
.top-menu{
  background: transparent !important;
  border-right: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.21);
  .el-menu{
    background: transparent !important;
  }
  .el-menu-item:hover{
    background: transparent !important;
  }
  .el-menu-item:focus{
    background: transparent !important;
  }
  .el-menu-item{
    color: #fff;
  }
  .is-active{
    color: rgb(255, 107, 53) !important;
  }
}
.el-menu--horizontal>.el-menu-item{
  color: #000;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 4px solid rgb(255, 107, 53) !important;
  color: rgb(255, 107, 53) !important;
}
.el-dropdown-menu__item, .el-menu-item{
  font-size: 16px !important;
  color: #000000;
}

.el-menu .el-menu-item{
  color: #000000;
}
.language-select {
  width: 120px;
  margin-right: 50px;
  .el-input__inner {
    border: 0;
    text-align: right;
  }
  .el-select-dropdown__item.selected {
    color: #FF6B35;
  }
    // 隐藏默认的下拉箭头
  :deep(.el-select__caret) {
    display: none;
  }

  // 输入框样式 - 模仿菜单项
  :deep(.el-input__wrapper) {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 15px;
    cursor: pointer;

    // 激活状态样式
    &.is-focus {
      .el-input__inner {
        color: #FF6B35;
      }
    }
  }

  // 输入框文字样式
  :deep(.el-input__inner) {
    color: inherit;
    cursor: pointer;
    text-align: center;
    width: 80px;
  }
}

// 下拉菜单全局样式
:deep(.language-select-dropdown) {
  border: none !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 100px !important;

  .el-select-dropdown__item {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    text-align: center;

    // 悬停效果
    &:hover {
      background-color: #f5f7fa;
    }

    // 激活项样式
    &.active-option {
      color: #FF6B35 !important;
      font-weight: 500;
    }

    // 选中样式
    &.selected {
      color: #FF6B35 !important;
      background-color: #fff !important;
    }
  }
}
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
  z-index: 100;
  /* 桌面版导航 */
  .desktop-nav {
    display: flex;
    align-items: center;
    height: 60px;
    margin: 0 auto;
    justify-content: space-between;
    .el-menu--horizontal {
      margin: 0 50px 0 auto;
      border-bottom: 0;
    }
  }

  .brand {
    color: var(--primary-color);
    font-size: 24px;
    margin-right: 40px;
  }

  .nav-items {
    display: flex;
    gap: 32px;
  }

  .nav-item {
    color: var(--text-color);
    cursor: pointer;
    position: relative;
    padding: 8px 0;
  }

  .nav-item.active {
    color: var(--primary-color);
  }

  .nav-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: var(--primary-color);
  }

  /* 子菜单 */
  .submenu {
    position: absolute;
    top: 64px;
    left: 15%;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 16px;
    min-width: 240px;
    display: none;
  }

  .submenu-item {
    padding: 12px;
    border-radius: 4px;
    margin: 4px 0;
    transition: background 0.2s;
  }

  .submenu-item:hover {
    background: #f5f5f5;
  }

  /* 移动端适配 */
  .mobile-nav {
    display: none;
  }

  .hamburger {
    width: 28px;
    height: 20px;
    position: relative;
    cursor: pointer;
  }

  .hamburger span {
    position: absolute;
    width: 100%;
    height: 3px;
    background: var(--text-color);
    transition: transform 0.3s;
  }

  .hamburger span:nth-child(1) {
    top: 0;
  }

  .hamburger span:nth-child(2) {
    top: 50%;
    transform: translateY(-50%);
  }

  .hamburger span:nth-child(3) {
    bottom: 0;
  }

  @media (max-width: 768px) {
    .desktop-nav {
      display: none;
    }

    .mobile-nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
    }

    .mobile-menu {
      position: fixed;
      top: 64px;
      left: 0;
      width: 100%;
      background: #fff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      height: 100%;
    }

    .mobile-menu.active {
      max-height: 100vh;
    }

    .mobile-menu-item {
      padding: 16px;
      border-bottom: 1px solid #eee;
    }

    .mobile-submenu {
      padding-left: 24px;
      background: #f8f9fa;
    }
  }


  .nav-container {
    padding-left: 140px;
  }

  .logo {
    position: absolute;
    top: 10px;
    left: 3%;
    font-size: 30px;
    font-weight: 700;
    color: #FF6B35;
  }

  /* 导航栏 */
  .navbar {
    background: #fff;
    padding: 1rem 5%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 1000;
  }

  .nav-links {
    display: flex;
    gap: 2rem;
  }

  .nav-links a {
    color: #004E7C;
    text-decoration: none;
    font-weight: 500;
  }
}
</style>
